
import Services from './base-services'

const service = new Services('demographic-items')

export default {
  getDemographicsItemsFromSuite: () => {
    return service.suiteOperation(() => service.get('list'))
  }
}
